import React, { Component } from "react";
import { Text, View, ScrollView, ActivityIndicator } from "react-native";
import {
    Flex,
    Padding,
    Margin,
    button,
    orderData,
    FontFamily,
    FontWeight,
    Colors,
} from "../../styles/appStyles";
import { helpers } from "../../utils/helpers";
import getImagePath from "../../utils/image-helper";
import Button from "../button";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { removeUserToken } from "../../../redux/User/user.actions";
import apiHelpers from "../../utils/api-helpers";
import CustomImage from "../custom-image";
import ButtonGradient from "../button-gradient";
import OrderView from "../order-view";
import ContentLoader from "../content-loader";
import AuthenticationWrapper from "../authentication-wrapper";
import { get, size, isEmpty } from "lodash";
import PlanCard from "./non-active-plan";

const cookies = new Cookies();

const sCreditsIcon = getImagePath("icons/sCredits.png");
const sCreditsIconDark = getImagePath("icons/sCreditsDark.png");
const silverCoin = getImagePath("icons/silver-coin.png");

export class TMCPrivate extends Component {
    constructor(props) {
        super(props);
        let webView = helpers.isWeb();
        const { isAuthenticated, fetchToken } = this.props.auth;
        let token = webView
            ? isAuthenticated
                ? fetchToken
                : false
            : this.props.user?.userData?.data?.token;
        this.state = {
            token: token == undefined || token == "" ? false : token,
            enableBtnLoader: false,
            credits: this.props.params ? this.props.params.credits : false,
            ordersData: false, // []
            pageLoader: this.props.params ? false : true,
            creditsLoader: true,
            locationInfo: false,
            plans: [],
            userProfile: {},
        };
    }

    componentDidMount = () => {
        this.getUserProfile();
        this.getLocationInfo();
    };

    getLocationInfo = () => {
        const { token } = this.state;
        let endpoint = `/location-info`;
        apiHelpers
            .apiRequest(endpoint, {}, "GET", true, token)
            .then((res) => {
                if (res.success) {
                    this.setState({ locationInfo: res.data });
                    const countryCode = res.data?.countryInfo?.code || "IN";
                    this.getPlans(countryCode);
                }
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    };

    getUserProfile = () => {
        const { token } = this.state;
        let endpoint = `/profile`;
        const body = {
            request_group: ["profile", "subscription"],
        };
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                if (res.success) {
                    this.setState({ userProfile: res.data, pageLoader: false });
                }
            })
            .catch((error) => {
                this.setState({
                    userProfile: {},
                    pageLoader: false,
                });
                console.log("Error=>> down", JSON.stringify(error));
            });
    };

    getPlans = (countryCode) => {
        const { token } = this.state;
        let endpoint = `/plans/${countryCode}`;
        let body = {
            rank_sort: "ASC",
        };
        apiHelpers
            .apiRequest(endpoint, body, "POST", true, token)
            .then((res) => {
                console.log("res=>>", JSON.stringify(res));
                if (res.success) {
                    const privatePlan = get(res.data, "plans.private", []);
                    this.setState({ plans: privatePlan });
                }
            })
            .catch((error) => {
                this.setState({ error: error.message });
            });
    };

    renderPageContent = () => {
        let { plans } = this.state;
        const { isAdmin, referenceId } = this.props;
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        const isSubscribedToTmcPrivate = !isEmpty(
            get(this.state.userProfile, "private_subscription", {}),
        );
        return (
            <>
                {size(plans) > 0 &&
                    plans.map((plan) => (
                        <PlanCard
                            key={plan.id}
                            plan={plan}
                            isSubscribedToTmcPrivate={isSubscribedToTmcPrivate}
                            userProfile={this.state.userProfile}
                        />
                    ))}
            </>
        );
    };

    showPageLoader = () => {
        const webView = helpers.isWeb();
        let darkMode = helpers.isDarkMode(this.props?.app?.DarkMode);
        return <ContentLoader darkMode={darkMode} />;
    };

    renderWebPage = () => {
        return <>{this.renderPageContent()}</>;
    };

    renderAppPage = () => {
        return (
            <>
                <ScrollView style={{ flex: 1 }}>{this.renderPageContent()}</ScrollView>
            </>
        );
    };

    render() {
        const webView = helpers.isWeb();
        let { showErrorModal, pageLoader } = this.state;
        return (
            <View>
                {pageLoader
                    ? this.showPageLoader()
                    : webView
                        ? this.renderWebPage()
                        : this.renderAppPage()}
            </View>
        );
    }
}

const mapStateToProps = (state) => {
    const { app, user } = state;
    return { app, user };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ removeUserToken }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AuthenticationWrapper(TMCPrivate));
